import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.5 4.375c0-1.034.84-1.875 1.875-1.875h11.25c1.034 0 1.875.84 1.875 1.875v8.438c0 1.034-.84 1.874-1.875 1.874h-4.063l-3.624 2.72a.47.47 0 0 1-.493.043.46.46 0 0 1-.258-.419v-2.343H4.376A1.877 1.877 0 0 1 2.5 12.812zm4.453 2.344a.7.7 0 0 0-.703.703c0 .39.313.703.703.703h6.094c.39 0 .703-.313.703-.703a.7.7 0 0 0-.703-.703zm0 2.812a.7.7 0 0 0-.703.703c0 .39.313.704.703.704h3.281c.39 0 .704-.314.704-.704a.7.7 0 0 0-.704-.703z"
    }, null, -1)
  ]))]))
}
export default { render: render }